<template>
  <div>
    <form-wizard
            subtitle="New Medicare Applications"
            @on-complete="onComplete"
            color="#5A5C5E"
            :step-size="wizardSize"
            class="mb-5"
            finish-button-text="Enroll Now"
    >
      <CustomTitle slot="title" :form="form" :relncodes="relnCodes" :showprint="showPrintButton"></CustomTitle>
      <tab-content title="Choose Plan" icon="ti-menu" :before-change="beforeTabSwitch1">
        <ValidationObserver ref="observer1">
          <choose-plan :form="form" :payerList="payerList" :style="enrollTabCss"/>
        </ValidationObserver>
      </tab-content>
      <tab-content title="Personal Information" icon="ti-user" :before-change="beforeTabSwitch2">
        <ValidationObserver ref="observer2">
          <personal-info :form="form" :style="enrollTabCss"/>
        </ValidationObserver>
      </tab-content>
      <tab-content
              title="Coverage Information"
              icon="ti-support"
              :before-change="beforeTabSwitch3"
      >
        <ValidationObserver ref="observer3">
          <coverage-info :form="form" :style="enrollTabCss"/>
        </ValidationObserver>
      </tab-content>
      <tab-content title="Payment Options" icon="ti-credit-card" :before-change="beforeTabSwitch4">
        <ValidationObserver ref="observer4">
          <payment-option :form="form" :style="enrollTabCss"/>
        </ValidationObserver>
      </tab-content>
      <tab-content title="Important Questions" icon="ti-flag-alt" :before-change="beforeTabSwitch5">
        <ValidationObserver ref="observer5">
          <important-question :form="form" :relncodes="relnCodes" :style="enrollTabCss"/>
        </ValidationObserver>
      </tab-content>
      <tab-content
              title="Attestation of Eligibility"
              icon="ti-pencil-alt"
              :before-change="beforeTabSwitch6"
      >
        <ValidationObserver ref="observer6">
          <attestation-eligibility :form="form" :style="enrollTabCss"/>
        </ValidationObserver>
      </tab-content>
      <tab-content title="Online Enrollment" icon="ti-check" :before-change="beforeTabSwitch7">
        <ValidationObserver ref="observer7">
          <online-enrollment :form="form" :relncodes="relnCodes" :style="enrollTabCss"/>
        </ValidationObserver>
      </tab-content>
      <a slot="custom-buttons-left" class="btn btn-light" @click="generateReport" v-if="showPrintButton">Preview & Download</a>
      <vue-html2pdf
              :show-layout="false"
              :float-layout="true"
              :enable-download="false"
              :preview-modal="true"
              :paginate-elements-by-height="1400"
              filename="Medicare Enrollment"
              :pdf-quality="2"
              pdf-format="a4"
              ref="html2Pdf"
              :html-to-pdf-options={margin:2}
      >
        <section slot="pdf-content">
          <preview-pdf slot="pdf-content" :form="form" :relncodes="relnCodes" v-if="previewFlag"></preview-pdf>
        </section>
      </vue-html2pdf>
      <loading :active.sync="submitting"
               :can-cancel="true"
               color="#5a5c5e"
               loader="dots"
               :height="25"
               :width="75"
               :opacity="0.7"
               background-color="#efefef"
               :is-full-page="true"></loading>
      <b-modal no-close-on-backdrop id="bv-modal-confirmation" size="" hide-footer @close="$bvModal.hide('bv-modal-confirmation'); redirectToPortal()">
        <template v-slot:modal-title>
          Successfully enrolled in
          <b>{{form.PayerPlan}}</b>
        </template>
        <div class="d-block text-center">
          <h3>
            The Application Reference ID is
            <br/>
            <b>
              <font color="green">{{saveResp[0].ApplicationReferenceNumber}}</font>
            </b>
          </h3>
          <hr />
          <span>Please note down the refrence ID for future use.</span>
        </div>
        <b-row>
          <b-col>
            <b-button class="col-12 mt-3 btn-info" block @click="printSection"><b-icon-printer-fill></b-icon-printer-fill> Print</b-button>
          </b-col >
          <b-col>
            <b-button class="col-12 mt-3 btn-info" block @click="$bvModal.hide('bv-modal-confirmation'); redirectToPortal()">Close</b-button>
          </b-col>
        </b-row>
      </b-modal>
        <div id="cofirmation-print">
            <div class="printBox">
              <b-img
                      :src=logoUrl alt="logo" class="printLogo"></b-img>
              <br>
                <h3>You have successfully applied for enrollment in {{form.PayerPlan}}.</h3>
                <h2>
                    Your Application Reference ID is
                    <br/>
                    <b class="greenText">{{saveResp[0].ApplicationReferenceNumber}}</b>
                    <!--                  <hr/>-->
                </h2>
                <h4 style="margin-top:10px;">Please keep it safe for future use.</h4>
                <div class="textRight" v-if="form.PayerPhoneNumber">
                  <b-icon-telephone-fill></b-icon-telephone-fill>
                  &nbsp;{{form.PayerPhoneNumber | VMask('(###)-###-####')}}
                </div>
            </div>
        </div>
    </form-wizard>
    <br>
  </div>


  <!-- </ValidationObserver> -->
</template>

<script>
import MedicareLeadsService from "../MedicareLeadsService";
import { FormWizard, TabContent } from "vue-form-wizard";
import ChoosePlan from "./partials/ChoosePlanComponent";
import PersonalInfo from "./partials/PersonalInformationComponent";
import CoverageInfo from "./partials/CoverageInfoComponent";
import PaymentOption from "./partials/PaymentOptionComponent";
import ImportantQuestion from "./partials/ImportantQuestionComponent";
import AttestationEligibility from "./partials/AttestationEligibilityComponent";
import OnlineEnrollment from "./partials/OnlineEnrollmentComponent";
import CustomTitle from "./partials/CustomTitleComponent";
import {BIconPrinterFill,BIconTelephoneFill} from 'bootstrap-vue'
//import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
//import { required, alpha } from "vee-validate/dist/rules";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import PreviewPdf from "./partials/PreviewPdfComponent";
import VueHtml2pdf from 'vue-html2pdf'

extend("confirmEmail", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Email confirmation does not match"
});
extend("atleastone", {
  validate(value) {
    return value > 0;
  },
  message: "Please select at least one statement."
});
extend("zipCodValid", {
  validate(value) {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
  },
  message: "Please enter valid zip code."
});

extend("mbiPattern", {
  validate(value) {
    return /^[1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z\d]\d(?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z\d]\d(?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z]\d{2}$/.test(value);
  },
  message: "Please enter valid Medicare Number."
});
extend("mbiLength", {
  validate(value) {
    return value && value.length == 11;
  },
  message: "Medicare Number should have 11 characters\n."
});
extend("min-phnum", {
  validate(value) {
    if (value) {
      let phonenumberonly = value
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/-/g, "");
      return phonenumberonly.length == 10;
    }
  },
  message: "{_field_} should always be 10 digits"
});
export default {
  name: "MedicareLeadsComponent",
  components: {
    FormWizard,
    TabContent,
    ChoosePlan,
    PersonalInfo,
    CoverageInfo,
    PaymentOption,
    ImportantQuestion,
    AttestationEligibility,
    OnlineEnrollment,
    CustomTitle,
    BIconPrinterFill,
    BIconTelephoneFill,
    Loading,
    PreviewPdf,
    VueHtml2pdf
  },
  data() {
    return {
      lookups: [],
      years: [],
      payerList: [],
      payers: {},
      zipCodes: {},
      payerid: "",
      planid: "",
      form: { PayerPlan: "", AttestationEligibility: {}},
      title: "",
      observerName: "",
      saveResp: [{}],
      wizardSize: 'md',
      logoUrl: '',
      submitting: false,
      showPrintButton: false,
      relnCodes: [],
      previewFlag: false,
      enrollTabCss: '',
      tabSwitchVal: 199
    };
  },
  async created() {
    this.form= { PayerPlan: "", AttestationEligibility: {}};
    try {
      if(process.env.VUE_APP_CLIENT){
        this.logoUrl = window.location.origin+'/images/logos/'+process.env.VUE_APP_CLIENT+'.png';
      }else{
        this.logoUrl = window.location.origin+'/images/logos/logo.png';
      }
      if(window.innerWidth<=1024){
        this.wizardSize = 'sm';
      }
      if(window.innerWidth<=520){
        this.wizardSize = 'xs';
      }
      this.lookups = await MedicareLeadsService.getMedicareLookUps();
      this.years = await MedicareLeadsService.getYears();
      if (this.years.length == 1) {
        this.form.year = this.years[0].LookupYear;
      }
      this.payerList = await MedicareLeadsService.getPayers();
      let relshipCodes = await MedicareLeadsService.getCodes('RELN');
      for (let i of relshipCodes) {
        if (i.Code !== '18') {
          let codeItem = {"value": i.Code, text: i.CodeName};
          this.relnCodes.push(codeItem);
        }
      }
    } catch (err) {
      this.error = err.message;
    }
  },
  methods: {
    async printSection() {
      await this.$htmlToPaper("cofirmation-print");
    },
    onComplete: async function() {
      this.submitting = true;
      this.form.Braille = this.form.infoPreferenceFormat=='BRAILLE' ? 1 : 0;
      this.form.LargeFont = this.form.infoPreferenceFormat=='LP' ? 1 : 0;
      this.form.paymentinterval = this.form.paymentinterval ? this.form.paymentinterval : 1;
      this.saveResp = await MedicareLeadsService.postMedicareLead(this.form);
      this.submitting = false;
      this.$bvModal.show("bv-modal-confirmation");
      //alert(JSON.stringify(this.saveResp));
    },
    getYears: function() {
      var yrs = {};
      this.years.forEach(element => {
        yrs[element.LookupYear] = element.LookupYear;
        // if (idx == this.years.length - 1) {
        //   this.form.year = element.LookupYear;
        // }
      });
      return yrs;
    },
    getPayers: function() {
      var payersList = [];
      this.lookups.forEach(element => {
        var payers = {};
        if (
          element.LookupCategory === "PAYER" &&
          element.LookupYear == this.form.year
        ) {
          payers["LookupID"] = element.LookupID;
          payers["LookupName"] = element.LookupName;
          payersList.push(payers);
        }
      });
      return payersList;
    },
    getPlans: function(payerid) {
      if (payerid) {
        var plansList = [];
        this.lookups.forEach(element => {
          var plans = {};
          if (
            element.LookupParentID == payerid &&
            element.LookupYear == this.form.year
          ) {
            plans["LookupID"] = element.LookupID;
            plans["LookupName"] = element.LookupName;
            plansList.push(plans);
          }
        });
        return plansList;
      } else {
        return [];
      }
    },
    async setPayernPlan (payerName, planName, payerID) {
      this.form.PayerPlan = payerName + " " + planName;
      this.form.PayerID = payerID;
      this.form.PayerName = payerName;
      this.form.PlanName = planName;
      let payerData = {};
      await this.payerList.forEach(function (each) {
        if(each.PayerID==payerID){
          payerData = each;
        }
      })
      this.form.PayerPhoneNumber = payerData.PhoneNumber;
      this.form.PayerPhoneNumberExtension = payerData.PhoneNumberExtension;
      this.form.PayerHoursOfOperation = payerData.HoursOfOperation;
      this.form.PayerPaymentText = payerData.PayerPaymentText;
      this.form.PayerPrivacyPolicy = payerData.PayerPrivacyPolicy;
      this.form.PayerImpText = payerData.PayerImpText;
      this.form.URLAddress = payerData.URLAddress;
    },
    beforeTabSwitch: function(obsName) {
      let items = Object.keys(this.$refs[obsName].errors);
      console.log(this.$refs[obsName].$children[0].$refs)
      for (var i = 0; i < items.length; i++) {
        const keyName = items[i];
        let value = this.$refs[obsName].errors[keyName].length;
        if (value > 0) {
          try {
            if (this.$refs[obsName].$children[0].$refs[keyName].isRadioGroup) {
              this.$refs[obsName].$children[0].$refs[keyName].$children[0].focus();
            } else {
              this.$refs[obsName].$children[0].$refs[keyName].focus();
            }
          } catch (e) {
            console.log("caught err---------->", e);
          }
          break;
        }
        if (i == items.length - 1) {
          const keyName = items[0];
          this.$refs[obsName].$children[0].$refs[keyName].focus();
        }
      }
    },
    beforeTabSwitch1: async function() {
      const valid = await this.$refs.observer1.validate();
      if (valid) {
        return true;
      } else {
        setTimeout(() => {
          this.beforeTabSwitch("observer1");
        }, 500);
      }
    },
    beforeTabSwitch2: async function() {
      const valid = await this.$refs.observer2.validate();
      if (valid) {
        return true;
      } else {
        setTimeout(() => {
          this.beforeTabSwitch("observer2");
        }, 500);
      }
    },
    beforeTabSwitch3: async function() {
      const valid = await this.$refs.observer3.validate();
      if (valid) {
        return true;
      } else {
        setTimeout(() => {
          this.beforeTabSwitch("observer3");
        }, 500);
      }
    },
    beforeTabSwitch4: async function() {
      const valid = await this.$refs.observer4.validate();
      if (valid) {
        return true;
      } else {
        setTimeout(() => {
          this.beforeTabSwitch("observer4");
        }, 500);
      }
    },
    beforeTabSwitch5: async function() {
      const valid = await this.$refs.observer5.validate();
      if (valid) {
        return true;
      } else {
        setTimeout(() => {
          this.beforeTabSwitch("observer5");
        }, 500);
      }
    },
    beforeTabSwitch6: async function() {
      const valid = await this.$refs.observer6.validate();
      this.showPrintButton = true;
      if (valid) {
        return true;
      } else {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.$refs.newtomedicare.focus();
      }
    },
    beforeTabSwitch7: async function() {
      const valid = await this.$refs.observer7.validate();
      if (valid) {
        if(this.form.acknowledgeAttest==='acknowledge'){
          if(this.form.MemberFname.toUpperCase()===this.form.attstFirstName.toUpperCase() && this.form.MemberLname.toUpperCase()===this.form.attstLastName.toUpperCase()){
            return true;
          }
          else{
            return false
          }
        }
        else{
          return true;
        }
      } else {
        setTimeout(() => {
          this.beforeTabSwitch("observer7");
        }, 500);
      }
    },
    reset: function(){
      location.reload();
    },
    redirectToPortal: function () {
      let urlAddr = this.form.URLAddress?this.form.URLAddress:'https://example.com';
      this.form= { PayerPlan: "", AttestationEligibility: {}};
      window.location = urlAddr;
    },
    async generateReport () {
      const valid = await this.$refs.observer7.validate();
      if (valid) {
        if(this.form.acknowledgeAttest==='acknowledge'){
          if(this.form.MemberFname.toUpperCase()===this.form.attstFirstName.toUpperCase() && this.form.MemberLname.toUpperCase()===this.form.attstLastName.toUpperCase()){
            this.previewFlag = true;
            this.enrollTabCss = 'display:none !important';
            await this.$refs.html2Pdf.generatePdf();
            this.previewFlag = false;
            this.enrollTabCss = 'display:block !important';
          }
          else{
            return false
          }
        }
        else{
          this.previewFlag = true;
          this.enrollTabCss = 'display:none !important';
          await this.$refs.html2Pdf.generatePdf();
          this.previewFlag = false;
          this.enrollTabCss = 'display:block !important';
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#cofirmation-print{
  display: none;
}
.wizard-tab-container {
  background-color: #6f727429 !important;
  min-height: 100px !important;
  border-radius: 7px !important;
  box-shadow: 3px 4px 6px 0px #5A5C5E !important;
  text-align: left !important;
  padding: 15px;
  color: #000;
}

.vue-form-wizard .wizard-title {
  color: #5A5C5E;
  font-weight: 600;
  font-size: 24pt;
  margin: 0;
  text-align: center;
}
.vue-form-wizard .wizard-nav-pills > li > a {
  color: rgb(166, 166, 171);
}
.inner-box-right {
  border-right: 1px solid #cbc6c6;
}

.add-info {
  font-size: 1.5ex;
}

.custom-req::after {
  content: "*";
  color: #c11616;
}

#checkbox-group-1 > div > label > span {
  font-weight: bold;
}

.error-span {
  color: #c11616;
  font-size: 12px;
}
.col > small {
  margin-top: -20px !important;
}
#AttestationofEligibility4 #example-i18n-picker__outer_ {
  margin-left: 25px;
  margin-bottom: 5pt !important;
}

#PersonalInformation1 .col-form-label {
  /*text-align: right !important;*/
  top: 0.4em;
  padding-right: 1em;
}
#PersonalInformation1 .custom-req::after {
  content: "*";
  color: #c11616;
  margin-right: -10px;
}
li.active .wizard-icon-circle{
  background: #5A5C5E;
}
@media screen and (max-width: 520px) {
  .wizard-tab-content{
    padding:20px 5px 10px !important;
  }
  .stepTitle{
    display:none;
  }
  .stepTitle.active{
    font-size:14px;
    display: block;
  }
  .customSmallInputGap{
    margin-top:5px;
  }
  .hideXS{
    display:none;
  }
  th, td{
    font-size:12px;
  }
}
</style>
<style lang="stylus">
.control {
  width: 100%;

  span {
    display: block;
  }

  input {
    padding: 5px 10px;
  }

  &.invalid {
    input, span {
      color: #c11616;
    }

    input, .b-form-datepicker {
      border: 1px #c11616 solid;
    }

    span {
      font-size: 12px;
    }
  }

  &.valid {
    input, span {
      color: #045929;
    }

    input {
      border: 1px #045929 solid;
    }
  }
}
</style>
